/**
 * Build and run the confetti animation
 * @param {object} canvas element ref
 * @param {number} duration in seconds to display
 * @param {boolean} clickable explode on click
 */
function initialize (canvas, duration, clickable) {
  let ctx = canvas.getContext('2d')
  let startTime = new Date().getTime()
  let currentTime = startTime
  let width, height

  let items = []
  let colors = [
    '#0095f7',
    '#ffffff',
    '#7579FF',
    '#ffffff',
    '#0095f7',
    '#7579FF',
    '#ffffff',
    '#0095f7'
  ]
  let index = 150
  let started = Date.now()

  function resize () {
    width = canvas.width = window.innerWidth
    height = canvas.height = window.innerHeight
  }

  function particle (x, y, i, minv) {
    let angle = Math.random() * (Math.PI * 2)
    let amount = Math.random() * 15.0 + minv
    let vx = Math.sin(angle) * amount
    let vy = Math.cos(angle) * amount

    return {
      x,
      y,
      vx,
      vy,
      width: Math.random() * 15 + 8,
      height: Math.random() * 20 + 8,
      color: colors[i % colors.length],
      circle: Math.random() > 0.8,
      rotate: Math.random() * 180,
      direction: Math.random() * 5 - 2.5,
      fallSpeed: Math.random() / 10 + 0.1
    }
  }

  function render () {
    ctx.clearRect(0, 0, width, height)
    let time = new Date().getTime()
    let delta = (time - currentTime) / (1000 / 60)
    currentTime = time

    if (time - startTime > 1500 &&
      (!duration || Date.now() < started + (duration * 1000))) {
      items[++index % 600] = particle(Math.random() * width, -20, index, 10)
    }

    items.forEach(item => {
      item.vx *= 1.0 - 0.05 * delta
      item.vy += delta * item.fallSpeed
      item.vy /= 1.0 + 0.05 * delta
      item.x += delta * item.vx
      item.y += delta * item.vy
      item.rotate += delta * item.direction

      ctx.fillStyle = item.color
      if (item.circle) {
        ctx.beginPath()
        ctx.arc(item.x, item.y, item.width / 2, 0, 2 * Math.PI)
        ctx.fill()
        ctx.closePath()
      } else {
        ctx.save()
        ctx.beginPath()
        ctx.translate(item.x, item.y)
        ctx.rotate((item.rotate * Math.PI) / 180)
        ctx.fillRect(-item.width / 2, -item.height / 2, item.width, item.height)
        ctx.translate(-item.x, -item.y)
        ctx.restore()
        ctx.closePath()
      }
    })

    window.requestAnimationFrame(render)
  }

  resize()
  for (let i = 0; i < index; i++) {
    items[i] = particle(width / 2, height / 2, i, 10)
  }

  if (clickable) {
    window.onclick = function (e) {
      for (let i = 0; i < 150; i++) {
        items[(index + 150 + i) % 600] = particle(e.clientX, e.clientY, i, 10)
      }
      index = (index + 150) % 600
    }
  }

  window.ontouchstart = e => {
    for (let d = 0; d < e.changedTouches.length; d++) {
      for (let i = 0; i < 150; i++) {
        items[(index + 150 + i) % 600] = particle(
          e.changedTouches[d].pageX,
          e.changedTouches[d].pageY,
          i,
          10
        )
      }
      index = (index + 150) % 600
    }
  }

  window.onresize = resize
  render()
}

export default {
  initialize
}



// WEBPACK FOOTER //
// ./src/components/Count/confetti.js